import React, { useId } from 'react';
import PropTypes from 'prop-types';

export default function Ring({
  width = 16,
  borderWidth = 1,
  percent = null,
  borderColor = 'black',
  backgroundColor = 'white',
  text = '',
  color = 'black',
  fontSize = (16 - 1) / Math.sqrt(2) / 2,
  isCell = false,
  mobileLabel = null,
}) {
  const titleId = useId();
  if (percent == null) {
    return null;
  }

  const height = width;
  const moveToX = width / 2;
  const moveToY = borderWidth / 2;
  const radius = (width - borderWidth) / 2;
  const largeArcFlag = percent > 50 ? 1 : 0;
  let angle = (360 * percent) / 100;

  if (angle >= 360) {
    angle = 359.99;
  }

  let x = 0;
  let y = 0;

  if (percent <= 25) {
    const radian = (angle * Math.PI) / 180;

    x = Math.sin(radian) * radius + width / 2;
    y = height / 2 - Math.cos(radian) * radius;
  } else if (percent > 25 && percent <= 50) {
    const radian = ((angle - 90) * Math.PI) / 180;

    x = Math.cos(radian) * radius + width / 2;
    y = Math.sin(radian) * radius + height / 2;
  } else if (percent > 50 && percent <= 75) {
    const radian = ((angle - 180) * Math.PI) / 180;

    x = width / 2 - Math.sin(radian) * radius;
    y = Math.cos(radian) * radius + height / 2;
  } else if (percent > 75) {
    const radian = ((angle - 270) * Math.PI) / 180;

    y = width / 2 - Math.sin(radian) * radius;
    x = height / 2 - Math.cos(radian) * radius;
  }

  return (
    <div className="progress-ring-container" {...(isCell ? { role: 'cell' } : {})}>
      {mobileLabel && <span className="mobile-col-label">{mobileLabel}</span>}
      <div className="progress-ring-wrapper">
        <div className="inner-ring" />
        <svg height={height} width={width} viewBox={`0 0 ${width} ${height}`} className="progress-ring" aria-labelledby={titleId}>
          <title id={titleId}>Progress: {text}</title>
          <path
            d={`M${moveToX} ${moveToY} A${radius} ${radius} 0 ${largeArcFlag} 1 ${x} ${y}`}
            stroke={borderColor}
            strokeWidth={borderWidth}
            fill={backgroundColor}
            strokeLinecap="butt"
          />
          <text x={width / 2} y={height / 2} fontSize={fontSize} textAnchor="middle" dominantBaseline="middle" fill={color}>
            {text}
          </text>
        </svg>
      </div>
    </div>
  );
}

Ring.propTypes = {
  width: PropTypes.number,
  percent: PropTypes.number,
  backgroundColor: PropTypes.string,
  borderColor: PropTypes.string,
  borderWidth: PropTypes.number,
  text: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.number,
  isCell: PropTypes.bool,
  mobileLabel: PropTypes.string,
};
